import CompaniesView from "../CompaniesView.vue";
import CompanyList from "../Pages/CompanyList.vue";
import CompanyEditor from "../Pages/CompanyEditor.vue";

const routes = [
  {
    path: '/empresas',
    component: CompaniesView,
    children: [
      {
        path: '',
        name: 'company-list',
        component: CompanyList,
      },
      {
        path: 'crear',
        name: 'company-create',
        component: CompanyEditor,
      },
      {
        path: ':id',
        name: 'company-edit',
        component: CompanyEditor
      },
    ]
  }
]

export default routes
